<template>
  <div class="sm:min-h-screen h-full banner">
    <img v-show="false" :src="bannerSource" @load="showHero" />
    <div :class="['hero-image', isBannerLoaded ? 'visible' : '']" :style="heroImage"></div>
    <div class="flex flex-col relative">
      <div class="absolute opacity-50 bg-primary-dark w-full h-full"></div>
      <div class="z-20 p-4 flex flex-col justify-between items-center">
        <Logo :inverted="true" />
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/shared/Logo'

const min = 1
const max = process.env.VUE_APP_MEDIA
const num = Math.floor(Math.random() * (max - min + 1)) + min

export default {
  data() {
    return {
      isBannerLoaded: false,
      motto: this.$store.getters['app/motto'],
      bannerSource: require(`@/assets/media/banner${num}.jpg`),
    }
  },
  methods: {
    showHero() {
      this.isBannerLoaded = true
    },
  },
  computed: {
    heroImage() {
      return {
        backgroundImage: 'url(' + this.bannerSource + ')',
      }
    },
  },
  components: {
    Logo,
  },
}
</script>

<style scoped>
.banner {
  @apply w-full flex flex-col items-center justify-start text-white relative z-10 bg-primary;
}

.hero-image {
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0;
  -webkit-transition: opacity 0.2s ease-in-out;
  -moz-transition: opacity 0.2s ease-in-out;
  -ms-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
}

.hero-image.visible {
  opacity: 0.35;
}
</style>
